jQuery(document).ready(function ($) {
	const $searchModal = $(".js-search");

	function openSearch() {
		$searchModal
			.removeClass("opacity-0 invisible")
			.addClass("opacity-100 visible");

		$("body").addClass("search-open");
	}

	function closeSearch() {
		$searchModal
			.removeClass("opacity-100 visible")
			.addClass("opacity-0 invisible");

		$("body").removeClass("search-open");
	}

	// Mobile open button
	$(document).on("click", ".mb-search", function (e) {
		e.preventDefault();

		openSearch();

		$searchModal.data("justOpened", true);

		setTimeout(() => {
			$searchModal.removeData("justOpened");
		}, 0);
	});

	// Close button
	$(document).on("click", ".custom-cart-close", function () {
		closeSearch();
	}); 

	// Close when clicking outside
	$(document).on("click", function (e) {
		if ($searchModal.data("justOpened")) return;

		if (
			!$searchModal.is(e.target) &&
			$searchModal.has(e.target).length === 0
		) {
			closeSearch();
		}
	});
});